import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpParagraphComponent} from './dcp-paragraph/dcp-paragraph.component';
import {ConfigModule} from '@spartacus/core';
import {SupplementHashAnchorsModule} from '@spartacus/storefront';
import {SafeResourceHtmlPipeModule} from '@app/pipes/safeResourceHtml/safeResourceHtml.module';


@NgModule({
  declarations: [
    DcpParagraphComponent
  ],
  imports: [
    CommonModule,
    SafeResourceHtmlPipeModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSParagraphComponent: {
          component: DcpParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: DcpParagraphComponent,
        },
      },
    }),
    SupplementHashAnchorsModule,
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class FixesModule {
}
